module.exports = __webpack_public_path__ + "img/women-img.bcc8c06b.png";